import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/object-ungroup': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M564 224h-12v160h12c6.6 0 12 5.4 12 12v72c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-12h-224v12c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-72c0-6.6 5.4-12 12-12h12v-24h-88v12c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-72c0-6.6 5.4-12 12-12h12v-160h-12c-6.6 0-12-5.4-12-12v-72c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v12h224v-12c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v72c0 6.6-5.4 12-12 12h-12v24h88v-12c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v72c0 6.6-5.4 12-12 12zM352 64v32h32v-32h-32zM352 320v32h32v-32h-32zM64 352v-32h-32v32h32zM64 96v-32h-32v32h32zM96 312h224v-12c0-6.6 5.4-12 12-12h12v-160h-12c-6.6 0-12-5.4-12-12v-12h-224v12c0 6.6-5.4 12-12 12h-12v160h12c6.6 0 12 5.4 12 12v12zM224 448v-32h-32v32h32zM504 384v-160h-12c-6.6 0-12-5.4-12-12v-12h-88v88h12c6.6 0 12 5.4 12 12v72c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-12h-88v24h12c6.6 0 12 5.4 12 12v12h224v-12c0-6.6 5.4-12 12-12h12zM544 448v-32h-32v32h32zM544 192v-32h-32v32h32z'
      }
    ]
  }
})
